<template>
  <div class="sign-in">
    <div class="ser">
      <div class="logoBox">
        <div class="imgBox"><img :src="logoImg" alt="" /></div>
        <div class="ProjectName">华东师范大学创新创业系统管理平台</div>
      </div>
    </div>
    <div class="ser">
      <div class="title-wrap">
        <!-- <div class="title-item">标题</div> -->
        <div class="title-item">登录</div>
      </div>

      <a-form :form="form" @submit="submit" class="sign-in-form">
        <a-form-item :colon="false" :label="$t('user.account')">
          <a-input
            :placeholder="$t('user.account')"
            v-decorator="[
              'member',
              {
                rules: [
                  {
                    required: true,
                    message: $t('public.pleaseFill', {
                      content: $t('user.account')
                    })
                  }
                ]
              }
            ]"
          >
          </a-input>
        </a-form-item>
        <a-form-item :colon="false" :label="`${$t('user.password')}`">
          <a-input
            :placeholder="$t('user.password')"
            type="password"
            v-decorator="[
              'password',
              {
                rules: [
                  {
                    required: true,
                    message: $t('public.pleaseFill', {
                      content: $t('user.password')
                    })
                  }
                ]
              }
            ]"
          >
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button block type="primary" html-type="submit">
            {{ $t('user.signIn') }}
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      logoImg: require('../../assets/logo/logo.jpg')
    }
  },

  computed: {
    ...mapGetters(['systemName', 'indexRouter'])
  },

  watch: {
    // 更新form检测信息的翻译
    '$i18n.locale'() {
      this.$nextTick(() => {
        const fieldsError = this.form.getFieldsError()
        let fieldsErrorName = []

        for (const key in fieldsError) {
          if (fieldsError[key]) {
            fieldsErrorName.push(key)
          }
        }

        if (fieldsErrorName.length > 0) {
          this.form.validateFields(fieldsErrorName, { force: true }, () => {})
        }
      })
    }
  },

  methods: {
    submit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.staffLogin({ member: values.member, password: values.password })
        }
      })
    },

    staffLogin(loginData) {
      this.$http(this.$api.LOGIN, {
        username: loginData.member,
        password: loginData.password
      }).then(r => {
        console.log(r)
        this.$message.success(this.$t('user.signInSuccess'))
        const date = new Date()
        this.$cookie.set('token', date.getTime(), { expires: 1 })
        localStorage.setItem('shuangchuanginfo', JSON.stringify(r.data))
        this.$router.push('/')
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../style/variable.less';

.sign-in {
  width: 800px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  overflow: hidden;
  background-color: #fff;
  height: 450px;
  border-radius: 20px;
  .ser:nth-child(1) {
    width: 50%;
    float: left;
    margin-top: 10%;
    .logoBox {
      width: 100%;
      margin-top: 40px;
      .imgBox {
        width: 180px;
        height: 180px;
        margin: 0 auto;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .ProjectName {
        text-align: center;
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        font-weight: 600;
      }
    }
  }
  .ser:nth-child(2) {
    box-sizing: border-box;
    width: 50%;
    float: left;
    margin-top: 10%;
  }
  .title-wrap {
    padding: 35px 25px 25px;
    color: black;
    .title-item {
      font-size: 24px;
      line-height: 1;
      text-align: center;
      // margin-top: 10px;
    }
  }
  .sign-in-form {
    margin-top: 20px;
    padding: 0 25px 15px 50px;
    .ant-form-item {
      .ant-btn {
        background-image: linear-gradient(to right, #f38365, #c3393a);
        border: none;
        height: 40px;
      }
    }
  }
}
</style>

<style lang="less">
.sign-in-form {
  .ant-form-item-label {
    line-height: 1;
  }
}
</style>
